import type { Monaco } from "@monaco-editor/react";
import {
  CUSTOM_LANGUAGE_ID,
  MONACO_THEMES,
  THEME_DEFINITIONS,
} from "../ChatInput.constants";

export function defineCustomThemes(monaco: Monaco) {
  const themeDefinitions = THEME_DEFINITIONS;
  monaco.editor.defineTheme(MONACO_THEMES.light, themeDefinitions.light);
  monaco.editor.defineTheme(MONACO_THEMES.dark, themeDefinitions.dark);
}

export function setMonacoTheme(monaco: Monaco, mode: "light" | "dark") {
  const themeName = mode === "dark" ? MONACO_THEMES.dark : MONACO_THEMES.light;
  monaco.editor.setTheme(themeName);
}

export function registerCustomLanguage(monaco: Monaco) {
  monaco.languages.register({ id: CUSTOM_LANGUAGE_ID });
}
